import * as ContentStore from './content-store';
import * as LocationStore from './location-store';
import * as MenuStore from './menu-store';
import * as MessageStore from './message-store';
import * as VideoStore from './video-store';
import { groupArrayByObjKey } from "../components/shared";

export class Stores {
    setContents(_contents) {
        const contents = _contents;

        ContentStore.set(contents);

        const contentsWithoutLocation = contents.filter( (content) => {
            return (content.type !== 'where');
        });

        ContentStore.setExcludeLocation(groupArrayByObjKey(contentsWithoutLocation,'type'));
        console.log(ContentStore.getExcludeLocation());
    }

    setLocations(_contents) {
        const locations = _contents.reduce( (acc,content) => {
            if (content.hasOwnProperty('location') && content.location !== null){
                const loc = content.location;
                acc.push( {
                    contentId: content.id,
                    type: content.type,
                    city_cn: loc.city_cn,
                    city_en: loc.city_en,
                    country_cn: loc.country_cn,
                    country_en: loc.country_en,
                    latitude: loc.latitude,
                    longitude: loc.longitude
                });
            }
            return acc;
        },[]);

        LocationStore.set(groupArrayByObjKey(locations,'city_en'));
        console.log(LocationStore.get());
    }

    setMenus(_menu) {
        MenuStore.set(_menu);
    }

    setMessages(_messages) {
        /**
         * add space between question (if any) and title
         *
         * struct
         * [{title_en: "", title_cn: ""},{title_en: "", title_cn: ""}]
         */
        const orderedMessages = this.ordering(_messages);
        const combinedMessage = orderedMessages.map( (message) => {
            const question_en = (message.question_en.length > 0)? message.question_en + ' \\s ' : '';
            // const question_cn = (message.question_cn.length > 0)? message.question_cn + 's' : '';

            return {
                title_en: question_en + message.title_en
                // title_cn: question_cn + message.title_cn
            };
        });

        const messages_en = combinedMessage.map( (message) => message.title_en);
        // const messages_cn = combinedMessage.map( (message) => message.title_cn);
        MessageStore.set(messages_en);

        console.log(MessageStore.get());
    }

    ordering(_arr) {
        return _arr.sort( (a, b) => a.ordering - b.ordering );
    }

    setVideos(_videos) {
         const videos = _videos.map( (video) => {
            return {
                name: video.name,
                url: video.video_src.url
            }
        });

        VideoStore.set(videos);
    }
}